import React, { Suspense, lazy } from 'react';

const ConfigureShadowResponseMapping = lazy(() =>
  import(/* webpackChunkName: "ConfigureShadowResponseMapping" */ '../../components/integrations/decipher/ConfigureShadowResponseMapping')
);

const LoadingFallback = () => (
  <div className="bc-white-50 rounded ba b--ddd shadow1 h9 d-flex jc-center align-center mt5">
    <div className="c-black-50">Loading...</div>
  </div>
);

export default function AsyncConfigureShadowResponseMapping({...props}) {
  return (
    <Suspense fallback={<LoadingFallback />}>
      <ConfigureShadowResponseMapping {...props} />
    </Suspense>
  );
}
